// extracted by mini-css-extract-plugin
export default {"button":"hWH3","left":"_2Bqu","center":"_2opz","container":"_3dY6","right":"_2tg4","buttons":"pEjt","input":"_1EkW"};